import React from 'react';

import { formatFullDate, formatTime } from 'Helpers/dateTimeService';

/**
 * The live clock: the time, with the date under it.
 *
 * TWO LINES, NOT THREE. The third named where the reading came from — "Sydney ·
 * AEST (from your regional settings)" — so a user seeing an unexpected time
 * knew the fix was in their own profile rather than in the page. The redesign
 * condenses this header, so that line was DROPPED, not moved: nothing else on
 * Home or in My details says it today. A user who questions the clock now has
 * to find the regional settings themselves.
 *
 * That is a real loss, small and deliberate, and the place to undo it is beside
 * the setting in My details — not by putting the sentence back on every load of
 * the landing page.
 *
 * `now` is passed in rather than held here: the greeting in the page header is
 * driven by the same instant, and two independent tickers could disagree. It
 * ticks for as long as the page is open — see useNow — so this never freezes at
 * the time the page happened to render.
 */
export default function HomeClock({ now }) {
    return (
        <div className="tw-text-end">
            <div className="tw-text-lg tw-font-semibold tw-text-charcoal tw-tabular-nums">{formatTime(now)}</div>
            <div className="tw-text-xs tw-text-charcoal-60">{formatFullDate(now)}</div>
        </div>
    );
}
